/**
 * SF-4653: every change of the run, by group, each one waiting, running, done or failed. A failed
 * change shows its reason exactly as sent: the chat service picks it from a fixed message table.
 */
import { List, Space, Tag, Typography } from 'antd';
import type { DemoBuildStep, DemoBuildStepStatus } from '../api/demoBuildsClient';
import { STEP_STATUS, groupSteps } from '../run';

export const StepStatusTag: React.FC<{ status: DemoBuildStepStatus }> = ({ status }) => {
  const s = STEP_STATUS[status] ?? STEP_STATUS.waiting;
  return <Tag color={s.color}>{s.label}</Tag>;
};

export const RunSteps: React.FC<{ steps: DemoBuildStep[] }> = ({ steps }) => (
  <Space direction="vertical" size="middle" style={{ width: '100%' }}>
    {groupSteps(steps).map(({ group, items }) => (
      <div key={group} data-testid="run-step-group">
        <Typography.Text strong>
          {group} ({items.length})
        </Typography.Text>
        <List
          size="small"
          dataSource={items}
          rowKey="ref"
          renderItem={(step) => (
            <List.Item data-testid="run-step" data-status={step.status}>
              <Space direction="vertical" size={0}>
                <Space>
                  <StepStatusTag status={step.status} />
                  <Typography.Text>{step.summary || step.ref}</Typography.Text>
                </Space>
                {step.status === 'failed' && step.error && (
                  <Typography.Text type="danger" data-testid="run-step-reason">
                    {step.error}
                  </Typography.Text>
                )}
              </Space>
            </List.Item>
          )}
        />
      </div>
    ))}
  </Space>
);
